import React, {useEffect, useState} from "react";
import ModalDefault from "../../../../common/components/modal/modal-default";
import {Field, FieldsManager} from "../../../../data/services/fields";
import {fieldsToHtml, fillFieldsFromData} from "../../../../common/util/util-fields";
import Resources from "../../../../data/services/resources";
import {DEFAULT_METADATA_SELECT_SEARCH_QUERY, UPDATE_PERM} from "../../../../util/util-constants";
import {useDispatch, useSelector} from "react-redux";
import {getJWT, getUser} from "../../../../common/util/util-auth";
import ResourceTable from "../../../../common/components/resource-table";
import {
    checkPerm,
    getDefaultContactGroup,
    getDefaultUserOfficeValues,
    getProp,
    openInNewTab
} from "../../../../common/util/util-helpers";
import {getDialogResource} from "../../../../data/actions/dialogResource";
import {getSecondResource} from "../../../../data/actions/secondResource";
import FileViewer from "../../../../common/components/file-viewer/components";
import Env from "../../../../util/env";
import XCircleIcon from "@heroicons/react/24/outline/XCircleIcon";
import {EyeIcon, PlusIcon} from "@heroicons/react/24/outline";
import FieldCellTextNew from "../../../../common/components/fields/field-cell-text-new";
import FieldCellSelectSearch from "../../../../common/components/fields/field-cell-select-search";
import FieldCellMoney from "../../../../common/components/fields/field-cell-money";
import XMarkIcon from "@heroicons/react/20/solid/XMarkIcon";
import LocalStorage from "../../../../util/localStorage";
import {createResource} from "../../../../data/actions/resource";
import {scrollErrorIntoView} from "../../../../common/util/util-vanilla";
import InfoParagraph from "../../../../common/components/info-paragraph";
import {Loader, LoaderLarge} from "../../../../common/components/loader";
import Tippy from "@tippyjs/react";


export default function WOPayProcessBill({show, translate, selectedItem, onClose, query}) {

    const dispatch = useDispatch();
    const [fields, setFields] = useState(getFields());
    const [rows, setRows] = useState({});
    const [rowsMisc, setRowsMisc] = useState({});
    const dialogResource = useSelector(state => state.dialogResource)
    const resource = useSelector(state => state.resource)
    const isDialogLoading = getProp(dialogResource, 'isLoading', false)
    const dataItems = getProp(dialogResource, 'data.Items', [])
    const defaults = getProp(resource, 'data.defaults', [])
    const dataMisc = getProp(dialogResource, 'data.Misc', [])
    const secondResource = useSelector(state => state.secondResource)
    const dataDocuments = getProp(secondResource, 'data.list', [])
    const [previewFile, setPreviewFile] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [attachments, setAttachments] = useState([]);
    const [isDocumentPreviewModalOpen, setIsDocumentPreviewModalOpen] = useState(false);
    const [attachmentFile, setAttachmentFile] = useState(null);
    const [internalNotes, setInternalNotes] = useState(selectedItem?.Notes);

    const renderCells = {
        ActionItem: (item) => {
            return <FieldCellTextNew
                name="ActionItem"
                value={item?.['ActionItem']}
                onChange={(name, value) => handleItemInputChange(name, value, item)}
                errorMessage={rows?.[item.index]?.['Description']?.errorMessage}
            />
        },
        AccountID: (item) => {
            return <FieldCellSelectSearch
                name="AccountID"
                value={{value: item?.['AccountID'], label: item?.['Account']}}
                onChange={(name, value) => handleItemInputChange(name, value, item)}
                placeholder={translate("text.no_account_selected")}
                isClearable={!!item?.['AccountID']}
                select={selects["AccountID"]}
                errorMessage={rows?.[item.index]?.['AccountID']?.errorMessage}
            />
        },
        ChargeToContactID: (item) => <FieldCellSelectSearch
            name="ChargeToContactID"
            value={{value: item?.['ChargeToContactID'], label: item?.['ChargeToContact']}}
            onChange={(name, value) => handleItemInputChange(name, value, item)}
            placeholder={translate("text.no_account_selected")}
            isClearable={!!item?.['ChargeToContactID']}
            select={selects["ChargeToContactID"]}
            errorMessage={rows?.[item.index]?.['ChargeToContactID']?.errorMessage}
        />,
        TotalAmount: (item) =>
            <div className="p-1 relative pr-6 h-11 w-32 ml-auto">
                <FieldCellMoney
                    name="TotalAmount"
                    value={item?.['TotalAmount']}
                    onChange={(name, value) => handleItemInputChange(name, value, item)}
                    errorMessage={rows?.[item.index]?.['Amount']?.errorMessage}
                />
            </div>
    }

    const renderMiscCells = {
        Description: (item) => {
            return <FieldCellTextNew
                name="Description"
                value={item?.['Description']}
                onChange={(name, value) => handleItemMiscInputChange(name, value, item)}
                errorMessage={rowsMisc?.[item.index]?.['Description']?.errorMessage}
            />
        },
        AccountID: (item) => <FieldCellSelectSearch
            name="AccountID"
            value={{value: item?.['AccountID'], label: item?.['Account']}}
            onChange={(name, value) => handleItemMiscInputChange(name, value, item)}
            placeholder={translate("text.no_account_selected")}
            isClearable={!!item?.['AccountID']}
            select={selects["AccountID"]}
            errorMessage={rowsMisc?.[item.index]?.['AccountID']?.errorMessage}
        />,
        ChargeToContactID: (item) => <FieldCellSelectSearch
            name="ChargeToContactID"
            value={{value: item?.['ChargeToContactID'], label: item?.['ChargeToContact']}}
            onChange={(name, value) => handleItemMiscInputChange(name, value, item)}
            placeholder={translate("text.no_account_selected")}
            isClearable={!!item?.['ChargeToContactID']}
            select={selects["ChargeToContactID"]}
            errorMessage={rowsMisc?.[item.index]?.['ChargeToContactID']?.errorMessage}
        />,
        TotalAmount: (item) =>
            <div className="p-1 relative pr-6 h-11 w-32 ml-auto">
                <FieldCellMoney
                    name="TotalAmount"
                    value={item?.['TotalAmount']}
                    onChange={(name, value) => handleItemMiscInputChange(name, value, item)}
                    errorMessage={rowsMisc?.[item.index]?.['TotalAmount']?.errorMessage}
                />
            </div>
    }

    function getFields() {
        const fieldTemplates = {
            ChargeOrganizationID: new Field('ChargeOrganizationID', !!selectedItem.AssignedVendorOrganizationID ? {
                label: selectedItem?.AssignedVendor,
                value: selectedItem?.AssignedVendorOrganizationID
            } : '', ['empty'], false, 'select-search', {
                addContainerClass: "col-span-4",
                label: "PayTo"
            }),
            CustomerReferenceNumber: new Field("CustomerReferenceNumber", selectedItem?.CustomerReferenceNumber, ['empty'], false, 'text', {addContainerClass: "col-span-2", label: "vendor_reference_number"}),
            Date: new Field('Date', selectedItem?.RequestDate, ['empty'], false, "date", {addContainerClass: "col-span-2"}),
            DueDate: new Field('DueDate', selectedItem?.RequestDate, ['empty'], false, 'date', {addContainerClass: "col-span-2"}),
            BookDate: new Field('BookDate', selectedItem?.RequestDate, ['empty'], false, 'date', {addContainerClass: "col-span-2"}),
            OfficeID: new Field('OfficeID', selectedItem?.OfficeID ? {
                label: selectedItem.Office,
                value: selectedItem.OfficeID
            } : getDefaultUserOfficeValues(), ['empty'], false, 'select-search', {addContainerClass: "col-span-2"}),
            ContactGroupID: new Field('ContactGroupID', selectedItem?.ContactGroupID ? {
                label: selectedItem.ContactGroup,
                value: selectedItem.ContactGroupID
            } : getDefaultContactGroup(), ['empty'], false, 'select-search', {addContainerClass: "col-span-2"}),
            TotalAmount: new Field('TotalAmount', 0, ['empty'], true, 'money', {addContainerClass: "col-span-2"})
        }
        return fieldTemplates;
    }

    function getFieldsItems(item = null) {
        const fieldTemplates = {
            ActionItem: new Field('ActionItem', '', [''], false, 'text', {addContainerClass: "col-span-2"}),
            AccountID: new Field('AccountID', '', ['empty'], false, 'select-search', {addContainerClass: "col-span-2"}),
            // Account: new Field('Account', '', [''], false, 'text', {addContainerClass: "col-span-2", hideTable: true}),
            ChargeToContactID: new Field('ChargeToContactID', '', [''], false, 'select-search', {addContainerClass: "col-span-2"}),
            Qty: new Field("Qty", 1, [''], false, 'float', {addContainerClass: "col-span-2", hideTable: true}),
            Amount: new Field('Amount', '', [''], false, 'money', {addContainerClass: "col-span-2", hideTable: true}),
            TotalAmount: new Field('TotalAmount', '', ['empty'], false, 'money', {addContainerClass: "col-span-2"})
        }

        let filledFields = fillFieldsFromData(fieldTemplates, item)
        if (item?.ChargeToContactID) {
            filledFields.AccountID.value = {value: defaults?.AdvancesAccountID, label: defaults?.AdvancesAccount}
            // filledFields.Account.value = defaults?.AdvancesAccount
        } else {
            filledFields.AccountID.value = {value: defaults?.ExpenseAccountID, label: defaults?.ExpenseAccount}
            // filledFields.Account.value = defaults?.ExpenseAccount
        }

        return filledFields
    }

    function getMiscFields(item = null) {
        const fieldTemplates = {
            Description: new Field('Description', '', [''], false, 'text', {addContainerClass: "col-span-2"}),
            AccountID: new Field('AccountID', '', ['empty'], false, 'select-search', {addContainerClass: "col-span-2"}),
            // Account: new Field('Account', '', [''], false, 'text', {addContainerClass: "col-span-2", hideTable: true}),
            ChargeToContactID: new Field('ChargeToContactID', '', [''], false, 'select-search', {addContainerClass: "col-span-2"}),
            Qty: new Field("Qty", 1, [''], false, 'float', {addContainerClass: "col-span-2", hideTable: true}),
            Amount: new Field('Amount', '', [''], false, 'money', {addContainerClass: "col-span-2", hideTable: true}),
            TotalAmount: new Field('TotalAmount', '', ['empty'], false, 'money', {addContainerClass: "col-span-2"})
        }

        let filledFields = fillFieldsFromData(fieldTemplates, item)
        if (item?.ChargeToContactID) {
            filledFields.AccountID.value = {value: defaults?.AdvancesAccountID, label: defaults?.AdvancesAccount}
            //filledFields.Account.value = defaults?.AdvancesAccount
        } else {
            filledFields.AccountID.value = {value: defaults?.ExpenseAccountID, label: defaults?.ExpenseAccount}
            //filledFields.Account.value = defaults?.ExpenseAccount
        }

        return filledFields
    }

    function getDocumentFields() {
        return {
            Description: new Field("Description", '', [], false, 'textarea'),
            DocumentTypeID: new Field("DocumentTypeID", '', ['empty'], false, 'select'),
            UpdatedByContact: new Field("UpdatedByContact", '', [''], false, 'custom', {
                render: (item) => <>{item.UpdatedByContact ?? this.props.translate("text.system")}</>,
                omitSort: true
            }),
            CreateUpdateDate: new Field("CreateUpdateDate", '', ['empty'], false, 'date')
        }
    }

    const handleFieldsInputChange = (name, value) => {
        setFields(FieldsManager.updateField(fields, name, value))
    }

    function calculateGrandTotal(rows, rowsMisc) {
        const rowsTotal = rows.reduce(
            (sum, row) => sum + (Number(row.TotalAmount?.value) || 0),
            0
        );

        const miscTotal = rowsMisc.reduce(
            (sum, row) => sum + (Number(row.TotalAmount?.value) || 0),
            0
        );

        return (Math.round((rowsTotal + miscTotal) * 100) / 100).toFixed(2);
    }


    function handleItemInputChange(name, value, item) {
        const itemsUpdate = [...rows];

        itemsUpdate[item.index][name].value = value;
        itemsUpdate[item.index][name].errorMessage = [];


        if (name === "TotalAmount") {
            const grandTotal = calculateGrandTotal(
                itemsUpdate,
                rowsMisc
            );

            setFields(prev =>
                FieldsManager.updateField(prev, "TotalAmount", grandTotal)
            );
        }

        setRows(itemsUpdate);
    }

    function handleItemMiscInputChange(name, value, item) {
        const itemsUpdate = [...rowsMisc];

        itemsUpdate[item.index][name].value = value;
        itemsUpdate[item.index][name].errorMessage = [];

        if (name === "TotalAmount") {
            const grandTotal = calculateGrandTotal(
                rows,
                itemsUpdate
            );

            setFields(prev =>
                FieldsManager.updateField(prev, "TotalAmount", grandTotal)
            );
        }

        setRowsMisc(itemsUpdate);
    }

    async function addToAttachments(item) {
        const url = Env.getApiUrl("api/" + Resources.WorkOrdersDocuments, {
            DocumentID: item?.DocumentID,
            token: getJWT().access_token,
            id: item?.WorkOrderID
        });


        const response = await fetch(url);
        const blob = await response.blob();

        const file = new File([blob], item?.OriginalFilename || "file", {type: blob.type});


        setAttachments(prev => [...prev, file]);
    }

    const selects = {
        OfficeID: {
            api: 'api/' + Resources.OfficesQuick,
            query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
            searchMap: (item) => ({
                label: item.OfficeName,
                value: item.OfficeID
            })
        },
        OrganizationID: {
            api: 'api/' + Resources.Organizations,
            query: {offset: 0, limit: 50},
            searchMap: (item) => ({
                value: item.OrganizationID,
                label: item.LegalName
            })
        },
        ChargeOrganizationID: {
            api: 'api/' + Resources.OrganizationsQuick,
            query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
            searchMap: (item) => ({
                label: item.LegalName,
                value: item.OrganizationID
            })
        },
        ChargeToContactID: {
            api: 'api/' + Resources.ContactsQuick,
            query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
            searchMap: (item) => ({
                label: item.FirstName + " " + item.LastName,
                value: item.ContactID
            })
        },
        AccountID: {
            api: 'api/' + Resources.AccountsQuick,
            query: {},
            searchMap: (item) => ({
                label: item.AccountName,
                value: item.AccountID
            })
        },
        ContactGroupID: {
            api: 'api/' + Resources.ContactGroupsQuick,
            query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
            searchMap: (item) => ({
                label: item.ContactGroupName,
                value: item.ContactGroupID
            })
        }
    }

    const basicFieldsToHtml = fieldsToHtml(Object.values(Object.assign({}, fields)), translate, (name, value) => handleFieldsInputChange(name, value), selects)

    const fetchData = () => {
        dispatch(getDialogResource({
            user: getUser(),
            resource: Resources.WorkOrderParts,
            query: {WorkOrderID: selectedItem?.WorkOrderID}
        }))
    }

    const fetchDocumentsData = () => {
        dispatch(getSecondResource({
            user: getUser(),
            resource: Resources.WorkOrdersDocuments,
            query: {id: selectedItem?.WorkOrderID, limit: 200}
        }))
    }

    useEffect(() => {
        fetchData();
        fetchDocumentsData();
    }, []);

    useEffect(() => {
        if (Array.isArray(rows) && Array.isArray(rowsMisc) && fields) {
            const grandTotal = calculateGrandTotal(rows, rowsMisc);

            setFields(prev =>
                FieldsManager.updateField(prev, "TotalAmount", grandTotal)
            );
        }
    }, [rows, rowsMisc]);

    useEffect(() => {
        if (!Array.isArray(dataItems)) return;

        const sumTotalAmount = (arr = []) =>
            arr.reduce((sum, x) => sum + (Number(x?.TotalAmount) || 0), 0);

        const buildRows = () => {
            return dataItems.map(originalItem => {
                const it = structuredClone(originalItem);

                const totalAmount =
                    sumTotalAmount(it.Labor) + sumTotalAmount(it.Parts);

                it.TotalAmount = totalAmount;

                const safeItem = structuredClone(it);

                return getFieldsItems(safeItem);
            });
        };

        const newRows = buildRows();

        setRows(prev =>
            prev.length === newRows.length &&
            prev.every((r, i) => r === newRows[i])
                ? prev
                : newRows
        );

        if (Array.isArray(dataMisc)) {
            const newRowsMisc = dataMisc.map(it =>
                getMiscFields(structuredClone(it))
            );

            setRowsMisc(prev =>
                prev.length === newRowsMisc.length &&
                prev.every((r, i) => r === newRowsMisc[i])
                    ? prev
                    : newRowsMisc
            );
        }

    }, [dataItems, dataMisc]);

    function getFormattedFields() {
        return Object.values(rows).map((it, index) => {
            return Object.assign({}, FieldsManager.getFieldKeyValues(it),
                {
                    index: index,
                    Account: it.AccountID?.value?.label,
                    ChargeToContact: it?.ChargeToContactID?.value?.label
                })
        })
    }

    function getFormattedFieldsMisc() {
        return Object.values(rowsMisc).map((it, index) => {
            return Object.assign({}, FieldsManager.getFieldKeyValues(it),
                {
                    index: index,
                    Account: it.AccountID?.value?.label,
                    ChargeToContact: it?.ChargeToContactID?.value?.label
                })
        })
    }

    function downloadPreview(uri, name) {
        const link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function onSubmit() {
        const paramsItems = rows.map(row => {
            const data = {
                ...row,
                Amount: row.TotalAmount
            };

            return FieldsManager.validateFields(data);
        });

        const paramsMisc = rowsMisc.map(row => {
            const data = {
                ...row,
                Amount: row.TotalAmount
            };

            return FieldsManager.validateFields(data);
        });

        const itemsChecked = paramsItems.map(item => ({
            ...item,
            hasError: !FieldsManager.checkFieldsForErrors(item)
        }));

        const miscChecked = paramsMisc.map(item => ({
            ...item,
            hasError: !FieldsManager.checkFieldsForErrors(item)
        }));

        const hasAnyError =
            itemsChecked.some(item => item.hasError) ||
            miscChecked.some(item => item.hasError);

        const noItemErrors = !hasAnyError;
        const validatedFields = FieldsManager.validateFields(fields);
        const fieldErrors = FieldsManager.checkFieldsForErrors(validatedFields);

        let params = {};
        if (noItemErrors && fieldErrors) {
            const paramsFields = FieldsManager.getFieldKeyValues(fields);
            paramsFields.Amount = paramsFields.TotalAmount;
            paramsFields.RefNumber = paramsFields.CustomerReferenceNumber;
            paramsFields.OrganizationID = paramsFields.ChargeOrganizationID;
            delete paramsFields.TotalAmount;
            delete paramsFields.CustomerReferenceNumber;
            delete paramsFields.ChargeOrganizationID;

            const itemsForApi = paramsItems.map(item => {
                const {ActionItem, ...rest} = FieldsManager.getFieldKeyValues(item);

                return {
                    ...rest,
                    Description: ActionItem
                };
            });

            const miscForApi = paramsMisc.map(item => FieldsManager.getFieldKeyValues(item));

            const combinedItems = [...itemsForApi, ...miscForApi]

            params = {
                ...paramsFields,
                WorkOrderID: selectedItem?.WorkOrderID,
                InternalNotes: internalNotes,
                Items: combinedItems
            };

            dispatch(createResource({
                user: LocalStorage.get('user'),
                params: params,
                resource: Resources.WorkOrdersPay,
                query: query,
                file: attachments,
                fileResource: Resources.AccountingExpenseDocumentsAdditional,
                errorMessage: true,
                successMessage: 'The work order has been processed.',
                piggyResource: Resources.WorkOrdersPay
            }))
            onClose();
        } else {
            setFields(validatedFields);
            setRows(paramsItems);
            setRowsMisc(paramsMisc);
            scrollErrorIntoView(rows);
            scrollErrorIntoView(rowsMisc);
            scrollErrorIntoView(fields);
        }
    }

    function onProcessAsPaid() {
        const paramsItems = rows.map(row => {
            const data = {
                ...row,
                Amount: row.TotalAmount
            };

            return FieldsManager.validateFields(data);
        });

        const paramsMisc = rowsMisc.map(row => {
            const data = {
                ...row,
                Amount: row.TotalAmount
            };

            return FieldsManager.validateFields(data);
        });

        const itemsChecked = paramsItems.map(item => ({
            ...item,
            hasError: !FieldsManager.checkFieldsForErrors(item)
        }));

        const miscChecked = paramsMisc.map(item => ({
            ...item,
            hasError: !FieldsManager.checkFieldsForErrors(item)
        }));

        const hasAnyError =
            itemsChecked.some(item => item.hasError) ||
            miscChecked.some(item => item.hasError);

        const noItemErrors = !hasAnyError;
        const validatedFields = FieldsManager.validateFields(fields);
        const fieldErrors = FieldsManager.checkFieldsForErrors(validatedFields);

        let params = {};
        if (noItemErrors && fieldErrors) {
            const paramsFields = FieldsManager.getFieldKeyValues(fields);
            paramsFields.Amount = 0;
            paramsFields.RefNumber = paramsFields.CustomerReferenceNumber;
            paramsFields.OrganizationID = paramsFields.ChargeOrganizationID;
            delete paramsFields.TotalAmount;
            delete paramsFields.CustomerReferenceNumber;
            delete paramsFields.ChargeOrganizationID;

            const itemsForApi = paramsItems.map(item => {
                const {ActionItem, ...rest} = FieldsManager.getFieldKeyValues(item);

                return {
                    ...rest,
                    Description: ActionItem,
                    Amount: 0,
                    TotalAmount: 0
                };
            });

            const miscForApi = paramsMisc.map(item => ({
                ...FieldsManager.getFieldKeyValues(item),
                Amount: 0,
                TotalAmount: 0
            }));
            const combinedItems = [...itemsForApi, ...miscForApi]

            params = {
                ...paramsFields,
                WorkOrderID: selectedItem?.WorkOrderID,
                InternalNotes: internalNotes,
                Items: combinedItems
            };

            dispatch(createResource({
                user: LocalStorage.get('user'),
                params: params,
                resource: Resources.WorkOrdersPay,
                query: query,
                file: attachments,
                fileResource: Resources.AccountingExpenseDocumentsAdditional,
                errorMessage: true,
                successMessage: 'The work order has been processed.',
                piggyResource: Resources.WorkOrdersPay
            }))
            onClose();
        } else {
            setFields(validatedFields);
            setRows(paramsItems);
            setRowsMisc(paramsMisc);
            scrollErrorIntoView(rows);
            scrollErrorIntoView(rowsMisc);
            scrollErrorIntoView(fields);
        }
    }

    return (
        <ModalDefault
            show={show}
            widthClass={'max-w-screen'}
            title={translate("text.process_bill")}

            customButtonsHTML={(
                <div className={'flex items-center'}>
                    {(
                        <Tippy
                            content={translate("text.process_as_paid")}
                        >
                            <button
                                className={"btn btn-primary"}
                                onClick={onProcessAsPaid}
                            >
                                {translate("btn.process_as_paid")}
                            </button>
                        </Tippy>
                    )}
                </div>
            )}
            // isLoading={isDialogLoading}
            closeButtonLabel={translate('Close')}
            onClose={onClose}
            onButtonClick={onSubmit}
            buttonDisabled={!dataItems.length && !dataMisc.length}
            buttonLabel={translate("btn.process")}
            customHtmlLeft={
                <ModalDefault
                    show={isDocumentPreviewModalOpen}
                    widthClass={'max-w-7xl'}
                    title={translate("modal_heading.Preview")}
                    limitHeight={true}
                    closeButtonLabel={translate('btn.close')}
                    onClose={() => {
                        setIsDocumentPreviewModalOpen(false);
                        setAttachmentFile(null);
                    }}
                    buttonLabel={translate('Download')}

                    onButtonClick={() => {
                        downloadPreview(URL.createObjectURL(attachmentFile), attachmentFile?.name)
                    }}
                >
                    {!!attachmentFile && (
                        <FileViewer
                            filePath={URL.createObjectURL(attachmentFile)}
                            fileType={attachmentFile?.name.split('.').pop()}
                            onError={(e) => {
                                console.log(e)
                            }}
                        />
                    )}
                </ModalDefault>
            }
        >
            {!!isDialogLoading && (
                <div className={"flex align-middle h-40"}>
                    <Loader/>
                </div>
            )}
            {!isDialogLoading && (
                <div className={"grid grid-cols-1 lg:grid-cols-2 divide-x divide-tm-gray-200"}>
            <div className={"grid cols-span-1"}>
                <div className={"grid grid-cols-6 gap-2 m-4"}>
                    {basicFieldsToHtml}
                </div>

                {!!dataItems.length && (
                    <div className="mt-6 mx-4">
                        <div className={"text-lg ml-4 mb-2"}>Items</div>
                        <ResourceTable
                            key={"Items"}
                            maxHeightClass="max-h-[calc(100vh-30rem)]"
                            data={getFormattedFields()}
                            fields={getFieldsItems()}
                            // options={this.itemsTableOptions}
                            renderCells={renderCells}
                            translate={translate}
                        />
                    </div>
                )}

                {!dataItems.length && !dataMisc.length && (
                    <InfoParagraph type={'danger'} message={translate("text.cant_create_no_billable_items")}
                                   className={"m-4"}/>
                )}

                {!!dataMisc.length && (
                    <div className="mt-6 mx-4">
                        <div className={"text-lg ml-4 mb-2"}>Misc</div>
                        <ResourceTable
                            key={"Misc"}
                            maxHeightClass="max-h-[calc(100vh-30rem)]"
                            data={getFormattedFieldsMisc()}
                            fields={getMiscFields()}
                            // options={this.itemsTableOptions}
                            renderCells={renderMiscCells}
                            translate={translate}
                        />
                    </div>
                )}

                <div className={"my-4 ml-4"}>
                    <div className={"text-xl"}>Attachments:</div>
                    <div>
                        {attachments.map((it, index) => {
                            return (
                                <div className={"ml-2"}>
                                    {index + 1}. {it.name}
                                    <button onClick={() => {
                                        setAttachmentFile(it);
                                        setIsDocumentPreviewModalOpen(true)
                                    }}>
                                        <EyeIcon className={"btn relative w-5 h-5 left-5 text-blue-400"}/>
                                    </button>

                                    <button
                                        onClick={() => setAttachments(prev => prev.filter(att => att.name !== it.name))}>
                                        <XMarkIcon className={"btn relative w-5 h-5 left-7 text-red-500"}/>
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            {!previewOpen ? (
                <div className={"m-4 grid grid-cols-3 text-lg"}>
                    {selectedItem?.TruckID && (
                        <button
                            className="col-span-1 btn text-lg text-primary min-w-0 break-words whitespace-normal text-left"
                                onClick={() => {
                                    if (checkPerm(Resources.TrucksInfo, UPDATE_PERM)) {
                                        openInNewTab(`/trucks/info/${selectedItem.TruckID}`);
                                    }
                                }}
                        >
                            Truck: {selectedItem?.Truck}
                        </button>
                    )}

                    {selectedItem?.TrailerID && (
                        <button
                            className="col-span-1 btn text-lg text-primary min-w-0 break-words whitespace-normal text-left"
                                onClick={() => {
                                    if (checkPerm(Resources.Trailer, UPDATE_PERM)) {
                                        openInNewTab(`/trailers/info/${selectedItem.TrailerID}`);
                                    }
                                }}
                        >
                            Trailer: {selectedItem?.Trailer}
                        </button>
                    )}

                    <div className="font-semibold min-w-0 break-words text-right col-start-3">
                        Work order number: {selectedItem?.AutoCounter}
                    </div>

                    <div className={"col-span-3"}>
                        <div className={"mb-2 ml-1"}>Internal notes</div>
                        <textarea
                            className="w-full min-h-[120px] resize-y rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 disabled:bg-gray-100"
                            value={internalNotes}
                            disabled={true}
                        />
                    </div>

                        <div className="mt-6 grid col-span-full text-xs">
                            <div className={"text-xl"}>Documents</div>
                            <ResourceTable
                                maxHeightClass="max-h-[calc(100vh-30rem)]"
                                data={dataDocuments}
                                fields={getDocumentFields()}
                                onView={(item) => {
                                    setPreviewFile(item);
                                    setPreviewOpen(true)
                                }}
                                actions={[
                                    {
                                        tooltipText: () => translate('btn.addAttachment'),
                                        visible: (item) => true,
                                        action: (item) => addToAttachments(item),
                                        icon: () => PlusIcon
                                    }
                                ]}
                                options={{
                                    style: {
                                        condensed: false,
                                        floatingActions: false,
                                        frozenActionColumn: true
                                    }
                                }}
                                translate={translate}
                            />
                        </div>
                    </div>
                ) : !!previewFile && previewOpen && (
                    <div className="min-w-full">
                        <div className="w-full max-w-full h-[500px] overflow-hidden border rounded-lg overflow-y-auto">
                            <div className="flex justify-end items-center">
                                <div className={"text-xl mr-auto m-4"}>File preview</div>

                                <button onClick={() => {
                                    setPreviewOpen(false);
                                }}
                                        className={"mr-4"}>
                                    <XCircleIcon className={"w-10 h-10"}/>
                                </button>
                            </div>
                            <FileViewer
                                filePath={Env.getApiUrl("api/" + Resources.WorkOrdersDocuments, Object.assign({}, {
                                    ['DocumentID']: previewFile && previewFile['DocumentID'],
                                    token: getJWT().access_token,
                                    id: previewFile.WorkOrderID
                                }))}
                                fileType={previewFile?.OriginalFilename?.split('.')?.pop()}

                                onError={(e) => {
                                    console.log(e)
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>)}
        </ModalDefault>
    )
}